import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import { Link } from "@reach/router";
import Toolbar from "@material-ui/core/Toolbar";
import store from "../../../reduxstore";
const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper
  }
}));

const infoNavContent = [
  { link: "goujians", label: "构件列表" },
  { link: "wenxians", label: "参考文献" },
  { link: "tiaowens", label: "构件条文" },
  { link: "test", label: "辨识实验" }
];

function InfoNavBar(props) {
  const classes = useStyles();
  const { nav } = props;
  //   const [value, setValue] = useState();
  const { account } = store.getState();
  //   function handleChange(event, newValue) {
  //     setValue(newValue);
  //   }

  return (
    <Toolbar disableGutters>
      <Tabs
        className={classes.root}
        value={nav}
        indicatorColor="secondary"
        textColor="secondary"
        variant="fullWidth"
      >
        {infoNavContent.map(({ label, link }) => (
          <Tab
            label={label}
            key={label}
            value={link}
            component={Link}
            to={`/info/${link}/`}
          />
        ))}
      </Tabs>
    </Toolbar>
  );
}

export default InfoNavBar;
